// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6925 ? "2c386607" : chunkId) + "." + {"818":"89a9a99c077f33a0","6743":"3138d63eda16398c","6925":"03fef5e379d5c8f7"}[chunkId] + ".js";
};